const productInfo = document.getElementsByClassName(
  "product__info-container"
)[0];
const productInfoWrapper = document.getElementsByClassName(
  "product__info-wrapper"
)[0];

function fixProductInfo() {
  const productInfoHeight = productInfo.getBoundingClientRect().height;

  window.addEventListener(
    "scroll",
    () => {
      let isSmallScreen = window.innerWidth < 750;
      let shouldChange = isSmallScreen
        ? productInfo.getBoundingClientRect().bottom < 220
        : productInfo.getBoundingClientRect().top <= 105;
      let shouldChangeBack = isSmallScreen
        ? productInfoWrapper.getBoundingClientRect().bottom >=
          productInfo.getBoundingClientRect().bottom
        : productInfoWrapper.getBoundingClientRect().bottom -
            productInfoHeight >=
          productInfo.getBoundingClientRect().top;
      let isFixed = productInfo.classList.contains("product__column-fixed");
      let isPlaceholder = productInfoWrapper.classList.contains(
        "product__info-wrapper--placeholder"
      );

      // console.log(productInfo.getBoundingClientRect().top);

      // console.log(
      //   isSmallScreen,
      //   shouldChange,
      //   shouldChangeBack,
      //   isFixed,
      //   isPlaceholder,
      //   productInfoHeight
      // );

      // console.log(
      //   productInfoWrapper.getBoundingClientRect().bottom -
      //     productInfoHeight,
      //   productInfo.getBoundingClientRect().top
      // );

      if (isSmallScreen) {
        productInfoWrapper.style.height = productInfoHeight + "px";
      }

      if (shouldChange) {
        if (!isFixed) {
          productInfo.classList.add("product__column-fixed");
        }

        if (isSmallScreen && !isPlaceholder) {
          productInfoWrapper.classList.add(
            "product__info-wrapper--placeholder"
          );
        }
      } else if (shouldChangeBack) {
        if (isFixed) {
          productInfo.classList.remove("product__column-fixed");
        }

        if (isSmallScreen && isPlaceholder) {
          productInfoWrapper.classList.remove(
            "product__info-wrapper--placeholder"
          );
        }
      }
    },
    false
  );
}

fixProductInfo();
